export default configs => ({
  control: base => ({
    ...base,
    border: 'none',
    position: 'relative',
    boxShadow: 'unset',
    borderRadius: 'unset',
    font: '300 13px Roboto, sans-serif',
  }),
  indicatorSeparator: base => ({
    display: 'none'
  }),
  menu: base => ({
    ...base,
    marginTop: 0,
    borderRadius: 0,
    boxShadow: '0 4px 2px -2px hsla(0,0%,0%,0.1), 0 4px 11px hsla(0,0%,0%,0.1)',
    font: "300 13px 'Roboto', sans-serif",
    margin: '8px 0'
  }),
  menuList: base => {
    return {
        ...base,
        padding: '0',
    };
  },
  dropdownIndicator: base => ({
    ...base,
    color: configs.mainColor
  }),
  option: (base, { data, isDisabled, isFocused, isSelected }) => {
    return {
        ...base,
        backgroundColor: isFocused ? '#f5f5f5' : undefined,
        color: '#000',
        padding: '8px',
        cursor: 'pointer',
        minHeight: '31px'
    };
  },
});
